// fab-menu.js — M3-Expressive-FAB-Menü: der FAB wird zum runden Schließen-Knopf, darüber stapeln sich
// bis zu sechs Aktionen als Pillen (rechtsbündig, gestaffelt einfedernd).
//   openFabMenu(fab, [{ value, label, icon }], { onSelect, label })
// Tastatur wie ein Menü (Pfeile, Pos1/Ende, Esc gibt den Fokus an den FAB zurück).
import { html, render } from '../core/h.js';
import { reducedMotion } from '../core/dom.js';

let current = null;
export const closeFabMenu = (reason) => current && current.close(reason);

/** Lage der Liste: über dem FAB, rechtsbündig an seiner rechten Kante. */
export function fabMenuPlacement(r, vw, vh, gap = 8) {
  return { right: Math.max(8, vw - r.right), bottom: Math.max(8, vh - r.top + gap) };
}

export function openFabMenu(fab, items, { onSelect, label } = {}) {
  closeFabMenu('replaced');
  const list = document.createElement('div');
  list.className = 'vc-fab-menu';
  list.setAttribute('role', 'menu');
  if (label) list.setAttribute('aria-label', label);
  render(list, html`${items.slice(0, 6).map((it, i) => html`<button type="button" class="vc-fab-menu-item" role="menuitem" tabindex="-1" data-i="${i}" style="--i:${items.length - 1 - i}">
    ${it.icon ? html`<span class="vc-icon" aria-hidden="true">${it.icon}</span>` : ''}<span>${it.label}</span></button>`)}`);
  document.body.appendChild(list);
  const place = () => {
    const p = fabMenuPlacement(fab.getBoundingClientRect(), document.documentElement.clientWidth, innerHeight);
    list.style.right = p.right + 'px'; list.style.bottom = p.bottom + 'px';
  };
  place();
  fab.classList.add('is-menu-open');
  fab.setAttribute('aria-expanded', 'true');
  const buttons = [...list.querySelectorAll('.vc-fab-menu-item')];
  let closed = false;
  const close = (reason) => {
    if (closed) return;
    closed = true; current = null;
    fab.classList.remove('is-menu-open');
    fab.setAttribute('aria-expanded', 'false');
    document.removeEventListener('pointerdown', outside, true);
    removeEventListener('resize', place);
    if (reducedMotion()) list.remove(); else { list.classList.add('is-closing'); setTimeout(() => list.remove(), 160); }
    if (reason !== 'outside' && reason !== 'replaced') fab.focus({ preventScroll: true });
  };
  const outside = (e) => { if (!list.contains(e.target) && !fab.contains(e.target)) close('outside'); };
  list.addEventListener('click', (e) => {
    const b = e.target.closest('.vc-fab-menu-item'); if (!b) return;
    const it = items[Number(b.dataset.i)];
    close('select');
    if (onSelect) onSelect(it.value, it);
  });
  list.addEventListener('keydown', (e) => {
    const i = buttons.indexOf(document.activeElement);
    const go = (n) => buttons[(n + buttons.length) % buttons.length].focus();
    if (e.key === 'ArrowDown') { e.preventDefault(); go(i + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); go(i - 1); }
    else if (e.key === 'Home') { e.preventDefault(); go(0); }
    else if (e.key === 'End') { e.preventDefault(); go(buttons.length - 1); }
    else if (e.key === 'Escape') { e.preventDefault(); close('escape'); }
    else if (e.key === 'Tab') close('tab');
  });
  setTimeout(() => document.addEventListener('pointerdown', outside, true));
  addEventListener('resize', place);
  // Fokus auf die Aktion direkt über dem FAB (die letzte der Liste)
  buttons[buttons.length - 1].focus({ preventScroll: true });
  current = { close };
  return current;
}

/** Klick auf den FAB schaltet das Menü (zweiter Klick schließt). */
export function toggleFabMenu(fab, items, opts) {
  if (fab.classList.contains('is-menu-open')) { closeFabMenu('toggle'); return null; }
  return openFabMenu(fab, items, opts);
}
